(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/16
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('promotion', {
                parent: 'module',
                url: '/promotion',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/promotion/promotion.html',
                        controller: 'PromotionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
